export default __webpack_public_path__ + "static/media/banner-460x200-bg-white-template.7f11c2de.svg";